<template>
  <div >
    <contenful-apis
      url="spaces/uhuxxitrg1zr/entries"
      :params="{ content_type: 'article', include: 3, 'fields.authors.sys.id': authorId, 'fields.youtubeVideoId\[exists\]': false }"
      :key-path="['articles'+authorId]"
    />
    <div
      v-if="articles && articles.items.length > 0"
      class="c-container">
      <div
        v-if="articles"
        class="v-subtitle">Articles</div>
      <div
        v-if="articles"
        :key="index"
        v-for="(article, index) in articles && articles.items">
        <router-link :to="`/article/${article.fields.slug}`">{{ article.fields.title }}</router-link>
      </div>
    </div>
  </div>
</template>

<style scoped>
.c-container {
  padding: 0 1em 1em 1em;
}
</style>
<style>
.v-subtitle {
  font-weight: 600;
  margin: 1em 0;
}
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "ArticleListAuthor",
  props: {
    authorId: {
      type: String
    }
  },
  computed: mapState({
    articles(state) {
      return (
        state.vuexApi[`articles${this.authorId}`] &&
        state.vuexApi[`articles${this.authorId}`].resp &&
        state.vuexApi[`articles${this.authorId}`].resp.data
      );
    },
    includes(state) {
      return (
        state.vuexApi[`articles${this.authorId}`] &&
        state.vuexApi[`articles${this.authorId}`].resp &&
        state.vuexApi[`articles${this.authorId}`].resp.data.includes
      );
    }
  })
};
</script>
